<template>


    <div id="bb1" class="flex nav01" v-if="show=='true'">

        <div class="flex nav0100">

            <div class="flex nav02" id="bb42">

                <div class="flex nav03">

                    <div class="flex nav060">
                        <div class="fe"></div>
<!-- 
                        <div class="flex nav080 nav081 imgolj1">
                            <router-link to="/" class="nav05 ">
                                <img src="@/assets/img/lokk.png" alt="">
                            </router-link>
                        </div> -->

                        <div class="flex nav080 nav081 ">
                                 <router-link to="/" class="nav05">
                                <img src="@/assets/img/logoes.png" alt="">
                            </router-link>

                            <div class="flex nav0600">
                                مدرسه مقاومت 
                            </div>
                        </div>




                    


                        <div class="flex  nav060items">
                            <div class="flex nav06 " >

                                <router-link to="/" class="alink11" id="bb2">
                                    خانه
                                </router-link>

                                <router-link to="/courses" class="alink11" id="bb3">
                                    آموزش ها
                                </router-link>
                                <router-link to="/library" class="alink11" id="bb23">
                                    کتابخانه
                                </router-link>
                                <router-link to="/festival" class="alink11" id="bb23">
                                    جشنواره ها و مسابقات
                                </router-link>
                                <router-link to="/research" class="alink11" id="bb23">
                                    پژوهش ها
                                </router-link>
                                <router-link to="/about-us" class="alink11" id="bb4">
                                    درباره ما
                                </router-link>

                                <router-link to="/linkus" class="alink11" id="bb4">
                                    ارتباط با ما
                                </router-link>
                                <div @click="downloadapp()" class="alink11" id="bb4">
                                    دانلود اپلیکشن
                                </div>
                            </div>

                        </div>



                        <div class="flex nav080 nav081">

                            <div class="flex nav041">

                                <span @click="open_drawer" class="flex nav042">


                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#313131"
                                        class="bi bi-list" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                            d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
                                    </svg>

                                </span>


                                <router-link to="/login" class="flex nav042">
                                    <svg fill="none" height="24" viewBox="0 0 24 24" width="24"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M17.7543 13.9997C18.9963 13.9997 20.0032 15.0065 20.0032 16.2486V16.824C20.0032 17.7183 19.6836 18.5831 19.1021 19.2625C17.5327 21.096 15.1455 22.0008 12.0001 22.0008C8.85426 22.0008 6.46825 21.0957 4.90194 19.2614C4.32218 18.5825 4.00366 17.719 4.00366 16.8262V16.2486C4.00366 15.0065 5.01052 13.9997 6.25254 13.9997H17.7543ZM17.7543 15.4997H6.25254C5.83895 15.4997 5.50366 15.835 5.50366 16.2486V16.8262C5.50366 17.3619 5.69477 17.88 6.04263 18.2874C7.29594 19.755 9.26182 20.5008 12.0001 20.5008C14.7384 20.5008 16.706 19.755 17.9625 18.2871C18.3114 17.8795 18.5032 17.3605 18.5032 16.824V16.2486C18.5032 15.835 18.1679 15.4997 17.7543 15.4997ZM12.0001 2.00439C14.7615 2.00439 17.0001 4.24297 17.0001 7.00439C17.0001 9.76582 14.7615 12.0044 12.0001 12.0044C9.2387 12.0044 7.00012 9.76582 7.00012 7.00439C7.00012 4.24297 9.2387 2.00439 12.0001 2.00439ZM12.0001 3.50439C10.0671 3.50439 8.50012 5.0714 8.50012 7.00439C8.50012 8.93739 10.0671 10.5044 12.0001 10.5044C13.9331 10.5044 15.5001 8.93739 15.5001 7.00439C15.5001 5.0714 13.9331 3.50439 12.0001 3.50439Z"
                                            fill="#313131" /></svg>
                                </router-link>

                            </div>

                       


                            
                            <div class="flex nav04">
                                <div class="flex nav07">
                                    <div class="nav09">
                                        <span class="nav11">
                                        </span>
                                        <span class="nav10">

                                        </span>
                                    </div>

                                    <router-link to="/login" class="nav12" id="bb5">{{mytitle}} </router-link>


                                </div>

                            </div>

                        </div>

                    </div>




                </div>













            </div>




        </div>



        <!---  LOGIN   -->

        <!-- <div v-if="show=='false'" class="flex nav02 change-to-w" id="bb42">

            <div class="flex nav03">

                <div class="flex nav060">

                    <router-link to="/" class="nav05">
                        <img src="@/assets/img/logoes.png" alt="">
                    </router-link>

                    <div class="nav050" @click="open_drawer">
                        <svg class="feather feather-menu" fill="none" stroke="#ffffff" stroke-linecap="round"
                            stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 12h18M3 6h18M3 18h18"></path>
                        </svg>
                    </div>



                    <div class="flex nav06">

                        <router-link to="/" class="alink11 changeb" id="bb2">
                            خانه
                        </router-link>

                        <router-link to="/courses" class="alink11 changeb" id="bb3">
                            آموزش ها
                        </router-link>
                        <router-link to="/library" class="alink11 changeb" id="bb23">
                            کتابخانه
                        </router-link>


                        <router-link to="/about-us" class="alink11 changeb" id="bb4">
                            درباره ما
                        </router-link>





                    </div>
                </div>




            </div>

            <div class="flex nav04">
                <div class="flex nav07">
                    <div class="nav09">
                        <span class="nav11">
                        </span>
                        <span class="nav10">

                        </span>
                    </div>

                    <router-link to="/login" class="nav12 changebuton" id="bb5">{{mytitle}} </router-link>


                </div>

            </div>


        </div> -->



    </div>

</template>

<script>
    // @ is an alias to /src
    import jQuery from 'jquery';
    let $ = jQuery;
    export default {
        props: ["islogin24", "panelPage"],
        name: 'HomeView',
        data() {
            return {
                islogins: false,
                flag: true,
                show: 'tt',
                mytitle: 'ورود / ثبت نام'

            }
        },
        methods: {
            downloadapp()
            {
                window.open('https://moghavematyar.ir/moghavematyar.apk');

            },
            open_drawer() {

                $(".main-drawer").removeClass("hide");
                $(".main-drawer").addClass("show");
                console.log('`1` :>> ', `1`);

                //$('.main-drawer').css('display', 'flex');
            },
            handleScroll() {
                if (window.scrollY > 200) {
                    document.getElementById("bb1").classList.add('change-to-w');
                    document.getElementById("bb2").classList.add("changeb");
                    document.getElementById("bb3").classList.add("changeb");
                    document.getElementById("bb4").classList.add("changeb");
                    document.getElementById("bb23").classList.add("changeb");
                    document.getElementById("bb42").classList.add("shadowb");


                    document.getElementById("bb5").classList.add("changebuton");
                    $('.feather-menu').css('stroke', '#000000');

                } else {
                    $('.feather-menu').css('stroke', '#ffffff');
                    document.getElementById("bb1").classList.remove('change-to-w');
                    document.getElementById("bb42").classList.remove("shadowb");

                    document.getElementById("bb2").classList.remove("changeb");
                    document.getElementById("bb3").classList.remove("changeb");
                    document.getElementById("bb4").classList.remove("changeb");
                    document.getElementById("bb23").classList.remove("changeb");
                    document.getElementById("bb5").classList.remove("changebuton");

                }
            },
            getCookie2(name) {
                var cookieArr = document.cookie.split(";");

                for (var i = 0; i < cookieArr.length; i++) {
                    var cookiePair = cookieArr[i].split("=");

                    if (name == cookiePair[0].trim()) {
                        return decodeURIComponent(cookiePair[1]);
                    }
                }

                // Return null if not found
                return null;
            }


        },
        mounted() {

            //this.alert("aa");

            var coo = getCookie('__infoo__c')
            if (coo != null) {
                var data1 = JSON.parse(coo)
                var data = data1[0];
                this.mytitle = data.family
            }


            function getCookie(name) {
                var cookieArr = document.cookie.split(";");

                for (var i = 0; i < cookieArr.length; i++) {
                    var cookiePair = cookieArr[i].split("=");

                    if (name == cookiePair[0].trim()) {
                        return decodeURIComponent(cookiePair[1]);
                    }
                }

                // Return null if not found
                return null;
            }


        },
        components: {},
        watch: {
          $route(to, from) {
                  console.log('to :>> ', to.name);
                   if ( !to.path.includes('/panel') ) {
                       this.show = 'true'
                   } else {
                     this.show = 'tt'
                   }
                   var coo = this.getCookie2('__infoo__c')
                   if (coo != null) {
                       var data1 = JSON.parse(coo)
                       var data = data1[0];
                       this.mytitle = data.family
                   } else {
                       this.mytitle = 'ورود / ثبت نام'

                   }
                   from;
                   ///this.show = false;
               }
        }
    }
</script>


<style scoped>
    @media (max-width: 1000px) {
        .nav0600 {
            font-size: 22px !important;
        }
    }

    .nav02 {


        padding: 0px 0px;
        background-color: #f9fafd;
        height: 80px;
        justify-content: space-between;





    }

    .change-to-w {
        background-color: #fff;

    }

    .change-to-w2 {
        background-color: #fff;
        color: #fff !important;

    }

    .changeb {
        color: #000 !important;
    }

    .changeb2 {
        color: #000 !important;
        border: 1px solid #000 !important;
    }

    @media (max-width: 1000px) {
        .nav06 {
            display: none !important;
        }

        .nav05 {

            padding-right: 10px !important;
        }

        .nav05 img {

            height: 60px !important;
            width: 50px !important;
        }

        .nav02 {
            padding: 0px !important;
        }


        .nav12 {
            min-width: 75px !important;
        }

        .nav050 {
            display: flex !important;
        }



    }


    @media (max-width: 400px) {

        .nav09 {
            display: none !important;
        }

    }

    .nav01 {
        /* position: fixed; */
        /* background-color: #f9fafd;
        background-color: #fff; */
        z-index: 9;
        transition: all .5s ease-out;


    }

    .shadowb {
        box-shadow: 0 3px 10px rgba(0, 0, 0, .05);
    }

    .nav05 {
        padding: 5px;
        justify-content: flex-start;
        display: flex;
        padding-right: 30px;
        padding-left: 0px;


    }

    .nav05 img {
        height: 75px;
        width: 75px;

    }

    .nav06 {
        justify-content: flex-start;
        margin-right: 25px;
        color: #fff;
        display: none;

    }

    .nav06 span {
        font-size: 13px;
        color: #ffffff;
        font-weight: 500;
        margin-right: 20px;
    }


    .nav07 {
        margin-left: 30px;
        justify-content: flex-end;
    }

    .nav12 {
        font-size: 14px;
        padding: 7px;
        border-radius: 7px;
        background-color: var(--btns);
        color: #fff;
        cursor: pointer;
        padding-right: 20px;
        padding-left: 20px;
        font-weight: 600;
        /* border: 1px solid #4f4f4f; */
        


    }

    .nav12:hover {
        background-color: var(--btnshover);;
    }


    .nav09 {
        padding: 5px;
        display: flex;
        padding: 5px;
        align-items: center;
        margin-left: 10px;
    }

    .nav10 {
        display: flex;
        align-items: center;
        padding: 3px;
    }

    .nav11 {
        display: flex;
        align-items: center;
        padding: 3px;
        color: #565656;
    }


    .alink11 {
        color: #494949;
        font-size: 17px;
        padding: 0px 20px;
        font-weight: 700;
        cursor: pointer;
        transition: all .4s ease-out;
    }

    .alink11:hover {
        color: #1c92c9;

    }

    .nav050 {
        display: none;
        align-items: center;
        height: 25px;
        width: 25px;
        padding-top: 10px;
        padding-right: 10px;
    }

    .nav060 {
        justify-content: flex-start;

    }

    .fixed64 {
        background-color: #fff;
    }

    .changebuton {
        background-color: var(--btns);
        color: #fff;
    }

    .changebuton:hover {
        background-color: var(--btnshover);
        color: #fff;
    }

    .nav0600 {

        display: flex;
        text-align: right;
        justify-content: flex-start;
        font-size: 23px;
        font-weight: 600;

        padding-top: 10px;


    }


    .nav908 {
        background-color: #f9fafd;
        height: 72px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

    }

    .nav0100 {
        display: flex;
        flex-direction: column;
        background-color: #dddddd;

    }


    .nav9080 {

        font-style: normal;
        margin-left: 20px;
        margin-right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;

        font-weight: bold;
        font-size: 17px;
        color: #363636;


    }

    .nav9080:hover {
        color: #009eec !important;

    }

    .nav90800 {
        color: #212121 !important;
    }

    .nav9089 {
        background-color: #bebebe;
        height: 22px;
        width: 1px;
    }


    .navsearching10 {
        flex-grow: 1;
        margin-left: 60px;
        display: flex;
        flex-grow: 1;
        margin-left: 80px;
        justify-content: left;
        align-items: flex-end;



    }



    .navsearching101 {
        width: 60px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 0px;
        border-left: 1px solid #bebebe;
        border-right: 1px solid #bebebe;

    }

    .navsearching102 {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        height: 70px;
        margin-left: 10px;
        flex-direction: column;
        font-size: 13px;
    }

    @media (max-width: 650px) {

        .nav908 {
            display: none !important;
        }

        .navsearching10 {
            display: none !important;
        }

        .navsearching102 {
            display: none !important;
        }

        .navsearching101 {
            display: none !important;
        }

        .nav90800 {
            margin-right: 0px !important;
        }

        .nav908 {
            justify-content: center;
        }
    }

    .nav060 {
        /*
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  pointer-events: none;
  background-image: url("~@/assets/imgmenue/MulticolorGlows.png");
  background-repeat: no-repeat;


  background-repeat: no-repeat;

  background-position: center;*/
  border-bottom :1px solid #aaaaaa3d  ;
    }


    @media (max-width: 650px) {
        .nav081 {
            flex: 0 0 50% !important;
            width: 50% !important;
        }

        .nav080 {
            flex: 0 0 0%;
            width: 0%;
        }

        .nav07 {
            margin-left: 10px !important;
        }

        .nav0600 {
            font-size: 21px !important;
        }

        .nav05 img {
            height: 60px !important;
            width: 50px !important;

        }


        .nav12 {
            font-size: 16px !important;

            background-color: #7c3e67;
            padding-right: 4px 12px !important;

        }



    }

    .imgolj2{
        display: none !important;
    }
   

   



    .nav080 {
        flex: 0 0 20%;
        width: 20%
    }


    .nav041 {
        justify-content: flex-end;
        display: none;
        padding-left: 15px;
  
    }

    .nav042 {
        border-radius: 50%;
  
        height: 45px;
        width: 45px;
        margin-left: 5px;
        margin-right: 5px;

    }

    @media (max-width: 400px) {

        .nav0600 {
            font-size: 18px !important;
        }

    }
    .nav06{
        display: flex;justify-content:center
    }
    .nav060items {
        flex: 0 0 60%;
        width: 60%;
      
    }
    
  
    @media (max-width: 1200px) {
  .nav060items {
            display: none !important;
        }
        .imgolj2{
            display: flex !important;


        }

        .imgolj1 {
display: none !important;
        }
        .nav562
        {
            display: none !important;
        }


        .nav081 {
            flex: 0 0 50% !important;
            width: 50% !important;
        }

        .nav04 {
            display: none !important;
        }

        .nav041 {
            display: flex !important;
        }
    }

</style>